import { atomWithStorage } from "jotai/utils";

import { jotaiLocalStorage } from "./storage";

export const onbordaAtom = atomWithStorage("onborda", false, jotaiLocalStorage);
